export type GscMintFailureReason = 'reconnect_required' | 'failed';

/**
 * Only `error: 'reconnect-required'` is a dead token. A bare 409 would send
 * them through OAuth for a transient conflict.
 */
export function toGscMintFailureReason(err: unknown): GscMintFailureReason {
  const { status, data } = (err ?? {}) as { status?: unknown; data?: unknown };
  if (status !== 409) {
    return 'failed';
  }
  const code = typeof data === 'object' && data !== null ? (data as { error?: unknown }).error : undefined;
  return code === 'reconnect-required' ? 'reconnect_required' : 'failed';
}
